import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultToolResource,
    ToolMutationResourceSchema,
    useToolActions,
} from '../../../../../resource/resources/artifacts/tool/toolResource';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { ToolContent } from './ToolContent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { Text } from '@mantine/core';

export const ToolView = ({ id }: { id: string | undefined }) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const toolActions = useToolActions()
    const toolQuery = toolActions.useGetResource(id);
    const updateTool = toolActions.useUpdateResource();
    const validateTool = toolActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: ToolMutationResourceSchema,
        defaultValues: defaultToolResource,
        submitHandler: async (data) => {
            await updateTool.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: toolQuery.data,
    });

    return (
        <QueryBaseComponent name="Tool" query={toolQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateTool.data}
                    metaDataInfo={toolQuery.data}
                    resourceType={ResourceType.TOOL}
                >
                    <Text c="dimmed">Tool</Text>
                </ResourceValidationTitleBar>
                <ToolContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
